import plan from "./plan.jpg";

const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

export const brevnov_byt_60Images: string[] = Object.entries(photoModules)
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const brevnov_byt_60FloorPlans: { image: string; label: string }[] = [
  { image: plan, label: "Půdorys" },
];
